import { render, staticRenderFns } from "./social-view-club-admin-tab-component.vue?vue&type=template&id=2aab8b75&scoped=true&lang=pug"
import script from "./social-view-club-admin-tab-component.js?vue&type=script&lang=js&external"
export * from "./social-view-club-admin-tab-component.js?vue&type=script&lang=js&external"
import style0 from "./social-view-club-admin-tab-component.vue?vue&type=style&index=0&id=2aab8b75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aab8b75",
  null
  
)

export default component.exports